/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { useTranslations } from 'next-intl'
import React from 'react'

const HeroSection: React.FC = () => {
  const t = useTranslations('HeroBackground')
  const title = t('title')
  const subtitle = t('subtitle')
  const description = t('description')
  const cta = t('cta')

  return (
    // Main container - relative positioning context for children
    <div className='relative w-full h-[660px] bg-gray-100 overflow-hidden'>
      {/* Ellipse 1 (Yellowish, Top Left) */}
      <div
        className='absolute opacity-40 w-[715px] h-[717px] bg-yellow-100 rounded-full
                   top-[-15%] left-[-10%] sm:top-[-25%] sm:left-[-15%] md:top-[-40%] md:left-[-20%]'
      ></div>

      {/* Circle 1 (Gray, Centerish) */}
      <div
        className='absolute opacity-50 w-[678px] h-[678px] bg-gray-200 rounded-full
                   top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2'
      ></div>
      <div
        className='absolute opacity-40 w-[715px] h-[717px] bg-yellow-100 rounded-full
                   bottom-[-25%] right-[-15%] sm:bottom-[-35%] sm:right-[-20%] md:bottom-[-50%] md:right-[-25%]'
      ></div>

      {/* Content Container - Centers the text visually within the central circle area */}
      <div className='absolute inset-0 flex flex-col items-center justify-center z-10 p-4'>
        {/* Added padding to prevent text hitting edges */}
        <div className='text-center max-w-lg md:max-w-xl'>
          {/* Title */}
          <h1
            className='font-sans font-bold
                         text-4xl sm:text-5xl md:text-6xl
                         mb-4 md:mb-6'
            style={{ color: '#231639' }}
          >
            {title}
          </h1>
          {/* Subtitle */}
          <p
            className='font-sans text-base sm:text-lg md:text-xl
                         mb-4 md:mb-6'
            style={{ color: '#313131' }}
          >
            {subtitle}
          </p>
          {/* Description */}
          <p
            className='font-sans text-sm sm:text-base md:text-lg
                         mb-6 md:mb-8'
            style={{ color: '#313131' }}
          >
            {description}
          </p>
          {/* Call to Action */}
          <p
            className='font-sans text-sm sm:text-base md:text-lg cursor-pointer hover:underline'
            style={{ color: '#313131' }}
          >
            {cta}
          </p>
        </div>
      </div>
    </div>
  )
}

export default HeroSection
